import React, { useState } from 'react';
import { addRecebivel } from '../../services/recebiveisService';
import Button from '../common/Button'; // Importando o botão genérico

function InserirRecebivel() {
  const [tipoRecebivel, setTipoRecebivel] = useState('');
  const [dadosRecebivel, setDadosRecebivel] = useState({
    descricao: '',
    valor: '',
    dataRecebimento: '',
    status: 'Pendente',
    clinica: '',
    paciente: '',
    tipo: '',
  });

  const handleTipoRecebivelChange = (e) => {
    const tipo = e.target.value;
    setTipoRecebivel(tipo);
    setDadosRecebivel((prev) => ({
      ...prev,
      tipo,
      clinica: tipo === 'plantao' ? prev.clinica : '',
      paciente: tipo === 'consulta' ? prev.paciente : '',
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !dadosRecebivel.descricao ||
      !dadosRecebivel.valor ||
      !dadosRecebivel.dataRecebimento
    ) {
      alert('Por favor, preencha todos os campos obrigatórios.');
      return;
    }

    try {
      await addRecebivel(dadosRecebivel);
      alert('Recebível adicionado com sucesso!');

      setDadosRecebivel({
        descricao: '',
        valor: '',
        dataRecebimento: '',
        status: 'Pendente',
        clinica: '',
        paciente: '',
        tipo: '',
      });
      setTipoRecebivel('');
    } catch (error) {
      console.error('Erro ao adicionar recebível:', error);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow-md">
      <div className="mb-4">
        <label className="block text-gray-700 font-semibold mb-2">
          Tipo de Recebível:
        </label>
        <select
          value={tipoRecebivel}
          onChange={handleTipoRecebivelChange}
          className="block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
        >
          <option value="">Selecione</option>
          <option value="plantao">Plantão em Clínica</option>
          <option value="consulta">Consulta Particular</option>
          <option value="procedimento">Procedimento Médico</option>
          <option value="consultoria">Consultoria/Assessoria Médica</option>
        </select>
      </div>

      <div className="mb-4">
        <label className="block text-gray-700 font-semibold mb-2">
          Descrição:
        </label>
        <input
          type="text"
          value={dadosRecebivel.descricao}
          onChange={(e) =>
            setDadosRecebivel({ ...dadosRecebivel, descricao: e.target.value })
          }
          className="block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          required
        />
      </div>

      <div className="mb-4">
        <label className="block text-gray-700 font-semibold mb-2">Valor:</label>
        <input
          type="number"
          value={dadosRecebivel.valor}
          onChange={(e) =>
            setDadosRecebivel({
              ...dadosRecebivel,
              valor: parseFloat(e.target.value),
            })
          }
          className="block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          required
        />
      </div>

      <div className="mb-4">
        <label className="block text-gray-700 font-semibold mb-2">
          Data de Recebimento:
        </label>
        <input
          type="date"
          value={dadosRecebivel.dataRecebimento}
          onChange={(e) =>
            setDadosRecebivel({
              ...dadosRecebivel,
              dataRecebimento: e.target.value,
            })
          }
          className="block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          required
        />
      </div>

      {tipoRecebivel === 'plantao' && (
        <div className="mb-4">
          <label className="block text-gray-700 font-semibold mb-2">
            Clínica:
          </label>
          <input
            type="text"
            value={dadosRecebivel.clinica}
            onChange={(e) =>
              setDadosRecebivel({ ...dadosRecebivel, clinica: e.target.value })
            }
            className="block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          />
        </div>
      )}

      {tipoRecebivel === 'consulta' && (
        <div className="mb-4">
          <label className="block text-gray-700 font-semibold mb-2">
            Paciente:
          </label>
          <input
            type="text"
            value={dadosRecebivel.paciente}
            onChange={(e) =>
              setDadosRecebivel({ ...dadosRecebivel, paciente: e.target.value })
            }
            className="block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          />
        </div>
      )}

      {/* Substituindo o botão "Adicionar Recebível" pelo componente genérico */}
      <Button
        type="salvar"
        label="Adicionar Recebível"
        className="py-2 px-4 text-white font-semibold rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
      />
    </form>
  );
}

export default InserirRecebivel;
